<script>
import { get } from "lodash";
import { rootMixin } from 'src/modules/inline_editing_module.js';
import { fandomRootMixin } from 'src/modules/fandom_mixins_module.js';
import { viewportMixin } from 'src/modules/viewport_module';
import { ActionCableRootMixin } from "src/modules/websocket_module.js";
import { fandomAnalyticsStartedMixin } from 'src/modules/fandom_analytics_module.js';

import EasyadminControls from 'easyadmin-controls';
import EmbeddableFooter from 'embeddable-footer';
import FullscreenModal from 'fullscreen-modal';
import LandingFooter from 'landing-footer';
import LandingHeader from 'landing-header';
import Navbar from "navbar";
import VideoPopup from "video-popup";

export default {
  el: '#vue-root',
  mixins: [fandomRootMixin, rootMixin, viewportMixin, fandomAnalyticsStartedMixin, ActionCableRootMixin],
  components: {
    EasyadminControls,
    EmbeddableFooter,
    FullscreenModal,
    LandingFooter,
    LandingHeader,
    Navbar,
    VideoPopup
  },
  mounted() {
    Fandom.jsEnabled();
    Fandom.flickityIOsFix([".flickity-carousel"]);
    Vue.nextTick(() => {
      if (!!window.location.hash) {
        Fandom.scrollToTop(window.location.hash);
      }
      const aux = $("#navbar-auxiliary");
      const main = $("#secondary-nav") || $("#main-navbar");
      const anchorHeight = main.height() + (aux ? aux.height() : 0);
      document.body.style.setProperty('--anchor-height', `${anchorHeight}px`);
    });
  },
  methods: {
    getContent: Fandom.getContent
  },
  computed: {
    mainContentLayout() {
      return get(this.mainContent, ["layout"], {});
    },
    mainContent() {
      return get(globalState.pageModel.name_to_content, [globalState.pageModel.main_content_name], {});
    },
    header() {
      if (this.mainContentLayout === 'page-landing') {
        return {
          navbar: get(globalState.pageModel.name_to_content, [globalState.pageModel.main_content_name, "header_items"], []),
          landing_button: get(globalState.pageModel.name_to_content, [globalState.pageModel.main_content_name, "landing_button"]),
          only_landing_button_mobile: get(globalState.pageModel.name_to_content, [globalState.pageModel.main_content_name, "only_landing_button_mobile"], false),
          logo: get(globalState.pageModel, ["layout", "header", "logo"])
        }
      } else {
        return get(globalState, ["pageModel", "layout", "header"]) || {}; 
      }
    },
    headerLayout() {
      return this.mainContentLayout === 'page-landing' ? 'landing-header' : 'navbar';
    },
    footer() {
      if (this.mainContentLayout === 'page-landing') {
        return {
          navbar: get(globalState.pageModel.name_to_content, [globalState.pageModel.main_content_name, "footer_items"], []),
          social_icons: get(globalState.pageModel.name_to_content, [globalState.pageModel.main_content_name, "social_icons"], null),
          landing_button: get(globalState.pageModel.name_to_content, [globalState.pageModel.main_content_name, "landing_button"]),
          landing_button_label: get(globalState.pageModel.name_to_content, [globalState.pageModel.main_content_name, "landing_button_label"]),
          disclaimer: get(globalState.pageModel, ["layout", "footer", "disclaimer"])
        }
      } else {
        return get(globalState, ["pageModel", "layout", "footer"]) || {}; 
      }
    },
    footerLayout() {
      return this.mainContentLayout === 'page-landing' ? 'landing-footer' : 'vue-footer';
    }
  }
};
</script>